/** Select the requested billing period only; missing annual links stay unavailable. */
export function publicCheckoutLink(plan, period) {
  if (period !== "month" && period !== "year") return null;
  const value = period === "year" ? plan?.annual_payment_link : plan?.payment_link;
  if (typeof value !== "string" || /[\s\u0000-\u001f\u007f]/.test(value)) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" && url.hostname === "buy.stripe.com" &&
      !url.username && !url.password && (!url.port || url.port === "443") &&
      url.pathname !== "/" ? value : null;
  } catch {
    return null;
  }
}
